<template>
  <div>
    <generic-container
      :title="$t('distribution revision')"
      icon="eye"
      :header_buttons="header_buttons"
    >
      <h2 class="ui dividing header">
        <i class="school icon"></i>
        <div class="content">
          {{ assignation.name }}
          <div class="sub header">
            {{ $t("from") }}
            <strong>{{
              assignation.start_date
                | formatDate(enterprise_setup.simple_date_format)
            }}</strong>
            {{ $t("to") }}
            <strong>{{
              assignation.end_date
                | formatDate(enterprise_setup.simple_date_format)
            }}</strong>
          </div>
        </div>
      </h2>
      <h4
        class="ui dividing header"
        v-if="assignation && assignation.setup && assignation.setup.general"
      >
        {{ $t("general") }}
      </h4>
      <div class="ui list">
        <div
          class="item"
          v-for="(grl, grlidx) in assignation.setup.general"
          :key="grlidx"
        >
          {{ grl.name }}: {{ grl.value }}
        </div>
      </div>
      <div
        v-if="assignation && assignation.courses && assignation.courses.length"
        class="ui grid"
      >
        <div class="four wide column">
          <h3 class="ui dividing header">
            {{ $t("courses") }}
          </h3>
          <div class="ui fluid search">
            <input
              class="prompt"
              type="text"
              :placeholder="$t('search course')"
              v-model="courseFilter"
            />
            <div class="results"></div>
          </div>
          <div class="ui vertical secondary menu" ref="tabs">
            <a
              class="item"
              v-for="(course, crsidx) in assignation.courses"
              :key="crsidx"
              :data-tab="'_' + course.uuid"
              v-show="
                courseFilter == '' ||
                  course.name.toLowerCase().includes(courseFilter.toLowerCase())
              "
              >{{ course.name }}</a
            >
          </div>
        </div>
        <div class="twelve wide column">
          <div
            class="ui bottom blue attached tab segment"
            v-for="(course, crsidx) in assignation.courses"
            :key="crsidx"
            :data-tab="'_' + course.uuid"
          >
            <course :course="course" :season="assignation" ref="course" />
          </div>
        </div>
      </div>
      <div v-else>
        <div class="ui error message">
          <div class="content">
            <div class="header">
              {{ $t("alert") }}
            </div>
            <p>{{ $t("no student is pre-inscribed in this season") }}</p>
          </div>
        </div>
      </div>
    </generic-container>
  </div>
</template>

<script>
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import {
  local_api,
  error_toast,
  success_toast,
  enterprise_setup,
} from "@/utils";
import Course from "./Course";

// @ is an alias to /src
export default {
  name: "CourseAssignationRevisionIndex",
  components: {
    "generic-container": GenericContainer,
    Course,
  },
  filters: filters,
  data() {
    return {
      courses: [],
      show_presinscription_modal: false,
      assignation: { setup: {} },
      header_buttons: [
        {
          icon: "refresh",
          tooltip: this.$t("refresh"),
          click: this.init,
        },
        {
          icon: "blue save",
          tooltip: this.$t("save all"),
          click: this.save,
        },
      ],
      courseFilter: "",
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    init() {
      let vm = this;
      let distribution_uuid = this.$route.query.i;
      if (distribution_uuid) {
        local_api(vm, "post", "/course/revision/do-get", {
          u: distribution_uuid,
        })
          .then((assignation) => {
            vm.assignation = assignation;

            // if (assignation && assignation.setup && assignation.setup.courses) {
            if (assignation && assignation.distinctCourses) {
              let ordered = assignation.distinctCourses
                .sort((a, b) => {
                  return a.name.localeCompare(b.name);
                  // if (a.name > b.name) return 1;
                  // else if (a.name < b.name) return -1;
                  // else return 0;
                })
                .map((c) => {
                  c.sections = [];
                  return c;
                });
              assignation.courses = ordered;
            }

            setTimeout(() => {
              window
                .jQuery(vm.$refs.tabs)
                .find(".item")
                .tab({
                  onFirstLoad(tabPath) {
                    let courseUuid = tabPath.substring(1);
                    local_api(vm, "post", "/course/revision/do-get-sections", {
                      s: distribution_uuid,
                      c: courseUuid,
                    })
                      .then((sects) => {
                        let trgtIndex = vm.assignation.courses.findIndex(
                          (c) => {
                            return c.uuid == courseUuid;
                          },
                        );
                        if (trgtIndex >= 0) {
                          vm.$refs.course[trgtIndex].set_sections(sects);

                          // vm.assignation.courses[trgtIndex].sections = sects;
                        }
                      })
                      .catch((err) => {
                        error_toast(err);
                      });
                  },
                });
            }, 1000);
          })
          .catch((err) => {
            error_toast(err);
          });
      } else {
        error_toast(this.$t("no course distribution found"));
      }
    },
    save() {
      let vm = this;
      local_api(vm, "post", "/course/revision/do-save", {
        s: vm.assignation.uuid,
      })
        .then((/* assignation */) => {
          success_toast(vm.$t("all sections were created"));
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  created() {},
  mounted() {
    let vm = this;
    vm.init();
  },
  watch: {},
};
</script>
